var map = {
	"./asset-hyperlink.json": 36885,
	"./blockquote.json": 42504,
	"./document.json": 83711,
	"./embedded-asset-block.json": 19039,
	"./embedded-entry-block.json": 12150,
	"./embedded-entry-inline.json": 2136,
	"./embedded-resource-block.json": 90012,
	"./embedded-resource-inline.json": 42439,
	"./entry-hyperlink.json": 99430,
	"./heading-1.json": 23542,
	"./heading-2.json": 29067,
	"./heading-3.json": 20297,
	"./heading-4.json": 37804,
	"./heading-5.json": 14899,
	"./heading-6.json": 22983,
	"./hr.json": 77634,
	"./hyperlink.json": 94529,
	"./list-item.json": 40102,
	"./ordered-list.json": 93743,
	"./paragraph.json": 80519,
	"./resource-hyperlink.json": 35344,
	"./table-cell.json": 3842,
	"./table-header-cell.json": 65016,
	"./table-row.json": 29699,
	"./table.json": 97393,
	"./text.json": 81811,
	"./unordered-list.json": 46770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23212;